import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnitResultView } from './passing-policy-results.service';
import { unitAggregateLine, unitStatusBadge } from './unit-pass-display.util';

/**
 * KAN-314 - shared readout for a unit's layered-passing-policy result. Renders
 * the aggregate % + Pass/Fail/Pending badge, plus any per-quiz point-floor (VS3)
 * or per-quiz-gate (VS2) violations. Used identically by the learner Course
 * Player and the instructor Gradebook so the two never diverge.
 */
@Component({
  selector: 'app-unit-pass-summary',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (result && result.status !== 'not_applicable') {
      <div class="text-sm" data-testid="unit-pass-summary">
        <span class="font-medium" data-testid="unit-aggregate-line">{{ aggregateLine }}</span>
        <span class="badge badge-sm ml-2" [class]="badgeClass" data-testid="unit-pass-badge">{{ badgeLabel }}</span>
        @for (fv of result.floorViolations; track fv.quizId) {
          <div class="text-error text-xs mt-1" data-testid="floor-violation">
            {{ fv.quizTitle || 'Quiz' }}: {{ fv.earnedPoints }} pts - minimum {{ fv.minRequired }} not met
          </div>
        }
        @for (gv of result.gateViolations; track gv.quizId) {
          <div class="text-error text-xs mt-1" data-testid="gate-violation">
            {{ gv.quizTitle || 'Quiz' }}: did not meet its own passing score
          </div>
        }
      </div>
    }
  `,
})
export class UnitPassSummaryComponent {
  @Input() result: UnitResultView | null = null;

  get aggregateLine(): string {
    return this.result ? unitAggregateLine(this.result) : '';
  }
  get badgeLabel(): string {
    return this.result ? unitStatusBadge(this.result.status).label : '';
  }
  get badgeClass(): string {
    return this.result ? unitStatusBadge(this.result.status).cssClass : '';
  }
}
